<template>
    <kgr-form-scaffold
        :pending="pending"
        edit-mode
        :with-primary-buttons="isEditable"
        @primaryBtnClicked="updateMember"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-data-provider
            :member-id="memberId"
            :callback="onMemberLoaded"
        >
            <div class="animated fadeIn">
                <kgr-member-contact-data-form
                    :member="member"
                    :error="error"
                    @enter="updateMember"
                />
            </div>
        </kgr-member-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import MemberContactDataForm from '../../components/members/MemberContactDataForm';
import MemberDataProvider from '../../components/data-provider/MemberDataProvider';
import MemberRepository from '../../js/repository/MemberRepository';

export default {
    components: {
        'kgr-member-data-provider': MemberDataProvider,
        'kgr-member-contact-data-form': MemberContactDataForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            member: null,
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onMemberLoaded(loadedMember) {
            this.member = loadedMember;
        },
        updateMember() {
            if (!this.isEditable) {
                return;
            }
            this.pending = true;
            MemberRepository.updateContact(this.member)
                .then(() => {
                    this.error = new Error();
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
